// helper
import { AlertNonButtonModalController } from "@/components/Modal/Generic/AlertNonButtonModal/AlertNonButtonModalController";
// AlertNonButtonModalController

export default function (modalStore) {
    const modalController = modalStore.methods.getModalController();
    if (modalController.alertModal == null) {
        modalController.setAlertNonButtonModal(new AlertNonButtonModalController())
    }

    /**@type {AlertNonButtonModalController} */
    const alertNonBtnModal = modalController.alertNonBtnModal

    return {
        alertNonBtnModal,
    }
}
